module.exports = __webpack_public_path__ + "static/media/centerBg.2a3c2f4d.png";